/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPentagonFill: {
  name: 'pentagon-fill';
  data: string;
} = {
  name: 'pentagon-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.854 1.983a1.5 1.5 0 0 0-1.708 0L1.832 5.662a1.5 1.5 0 0 0-.57 1.708l2.036 6.104A1.5 1.5 0 0 0 4.72 14.5h6.558a1.5 1.5 0 0 0 1.423-1.026l2.035-6.104a1.5 1.5 0 0 0-.569-1.708L8.854 1.983Z" fill="currentColor"/></svg>`,
};
